<template>
  <div class="user-absence-block">
    <h3 :class="{ 'mt-3': margin }">Current absences</h3>
    <b-list-group>
      <b-list-group-item v-for="(v) in currentAbsences" :key="v.id" class="p-1">
        <div class="absences-wrapper">
          <b-img rounded="circle" class="profile-img" :src="`/api/user/${v.jira_user_id}/photo?token=${token}`" />
          <div class="overflow-hidden mt-1">
            <div class="mb-1">
              <b-row>
                <b-col>
                  {{ v.name }}
                </b-col>
                <b-col cols="auto">
                  <template v-if="absenceDescription(v)">
                    <b-badge :variant="absenceVariant(v)" class="active-absence-badge float-right" pill>
                      {{ absenceDescription(v) }}
                    </b-badge>
                  </template>
                </b-col>
              </b-row>
            </div>
            <div class="absence-dates">
              <div :class="['month-block', { 'even-month': extendedView && d.month % 2 == 0 }]" v-for="d in v.days"
                :key="`${v.id}-${d.date.format()}`">
                <span :class="['day-bubble', { 'absence': d.isAbsence, 'weekend': d.isWeekend, 'today': d.isToday }]"
                  v-b-tooltip.hover.top :title="toolTipTitle(d)">
                  {{ d.n }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
    <h3 :class="{ 'mt-3': margin }">Nearby absences</h3>
    <b-list-group>
      <b-list-group-item v-for="(v) in nearbyAbsences" :key="v.id" class="p-1">
        <div class="absences-wrapper">
          <b-img rounded="circle" class="profile-img" :src="`/api/user/${v.jira_user_id}/photo?token=${token}`" />
          <div class="overflow-hidden mt-1">
            <div class="mb-1">
              <b-row>
                <b-col>
                  {{ v.name }}
                </b-col>
                <b-col cols="auto">
                  <template v-if="absenceDescription(v)">
                    <b-badge :variant="absenceVariant(v)" class="active-absence-badge float-right" pill>
                      {{ absenceDescription(v) }}
                    </b-badge>
                  </template>
                </b-col>
              </b-row>
            </div>
            <div class="absence-dates">
              <div :class="['month-block', { 'even-month': extendedView && d.month % 2 == 0 }]" v-for="d in v.days"
                :key="`${v.id}-${d.date.format()}`">
                <span :class="['day-bubble', { 'absence': d.isAbsence, 'weekend': d.isWeekend, 'today': d.isToday }]"
                  v-b-tooltip.hover.top :title="toolTipTitle(d)">
                  {{ d.n }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>

    <b-col :class="{ 'mt-3': margin }">
      <b-row><span class="day-bubble absence">o</span>:Absent</b-row>
      <b-row><span class="day-bubble">o</span>:Not absent</b-row>
    </b-col>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment, { relativeTimeThreshold } from 'moment';
import Services from '@/services';

export default {
  mounted() {
    this.init();
  },
  props: {
    margin: {
      type: Boolean,
      default: false,
    },
    days: {
      type: Number,
      default: 14,
    },
    extendedView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dayNames: ['P', 'O', 'T', 'C', 'Pk', 'S', 'Sv'],
      absences: [],
      queryDays: this.days,
    };
  },
  components: {
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),

    currentAbsences() {
      return this.absences
        .filter((v) => v.active)
        .sort((a, b) => {
          return b.end - a.end;
        });;
    },

    nearbyAbsences() {
      return this.absences
        .filter((v) => !v.active)
        .sort((a, b) => {
          return a.start - b.start;
        });
    }

  },
  watch: {

  },
  methods: {
    init() {
      Services.dash.Absences({ days: this.queryDays }).then(({ data }) => {
        data.absences.forEach((v) => {
          let diff = this.queryDays;
          const days = [];
          for (let i = 0; i < diff; i++) {
            const d = moment(moment().startOf('day')).add(i, 'days');
            days.push({
              weekday: d.isoWeekday(),
              date: d,
              isAbsence: d.isBetween(moment(v.start), moment(v.end), 'days', '[]'),
              isWeekend: d.isoWeekday() >= 6,
              isToday: moment().isSame(d, 'day'),
              n: (this.extendedView && this.firstVacationDay(v.start, d)) ? d.format('D') : this.dayNames[d.isoWeekday() - 1],
              month: d.month(),
            });
          }

          this.absences.push(
            {
              ...v,
              start: moment(v.start),
              end: moment(v.end),
              active: moment(v.start).isSameOrBefore(moment()) && moment(v.end).isSameOrAfter(moment().startOf('day')),
              days,
              type: v.type
            }
          )
        });
      });
    },

    absenceDescription(absence) {
      switch (absence.type) {
        case "Vacation":
          return "Vacation";
        case "Business trip":
          return "Business trip";
        default:
          return null;
      }
    },

    absenceVariant(absence) {
      return absence.type === "Vacation" ? "success" : "primary";
    },

    firstVacationDay(vacationStart, iteratedDate) {
      return iteratedDate.isSame(vacationStart, 'day')
    },

    toolTipTitle(d) {
      return this.extendedView ? d.date.format('YYYY-MM-DD') : null
    }
  }
};

</script>

<style lang=scss>
.day-bubble {
  border-radius: 50%;
  display: inline-block;
  border: solid 1px $primary;
  background-color: $white;
  line-height: 1.4em;
  // font-weight: bold;
  font-size: 0.8em;
  width: 1.6em;
  height: 1.6em;
  text-align: center;
  margin-top: 0.2em;
  margin-right: 0.05em;
  // vertical-align: top;

  &.absence {
    background-color: $primary;
    color: $white;
    font-weight: bold;
  }

  &.weekend {
    border-color: $red;

    &.absence {
      background-color: lighten($primary, 20%)
    }

    ;
    // color: $black;
  }

  &.today {
    border-color: $green;
  }

}

.user-absence-block .list-group-item {
  border-color: $gray;
  padding-top: 0 !important;
  padding-bottom: 0.1em !important;

}

.user-absence-block {
  min-width: 265px;

  .badge.active-absence-badge {
    vertical-align: top;
  }

  .absence-dates {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-top: -0.6em;
    font-size: 0.8em;
  }

  .profile-img {
    max-height: 3.2em;
    border: solid 1px white;
    margin-right: 0.2em;
  }
}

.month-block {
  &.even-month {
    background-color: rgb(160, 160, 160);
  }
}

.absences-wrapper {
  display: grid;
  grid-template-columns: min-content 1fr;
}
</style>
